import React from 'react';

interface LoadingOverlayProps {
  loadingStep: number;
  loadingSteps: string[];
}

export default function LoadingOverlay({ loadingStep, loadingSteps }: LoadingOverlayProps) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 text-center">
        <div className="relative w-40 h-40 mx-auto mb-6">
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full" />
          <div 
            className="absolute inset-0 border-4 border-transparent border-t-[#2A4365] rounded-full animate-spin"
            style={{
              background: 'linear-gradient(to right, transparent, transparent 50%, #4A5568 50%, #C4A052)',
              WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude'
            }}
          />
        </div>
        <p className="text-2xl font-semibold text-gray-900 mb-2">
          {loadingSteps[loadingStep]}
        </p>
        <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
          <div 
            className="h-2 rounded-full transition-all duration-300"
            style={{
              width: `${((loadingStep + 1) / loadingSteps.length) * 100}%`,
              background: 'linear-gradient(to right, #2A4365, #4A5568, #C4A052)'
            }}
          />
        </div>
      </div>
    </div>
  );
}